import { styled } from 'baseui'

export const StyledContainer = styled('div', () => ({
  width: '100%',
  padding: '0rem',
}))

export const UpdatedAt = styled('span', ({ $theme }) => ({
  fontSize: '0.6875rem',
  lineHeight: '1rem',
  color: $theme.colors.textDimmed,
  whiteSpace: 'nowrap',
}))

export const NoteWrapper = styled('div', {
  paddingTop: 0,
  paddingBottom: '0.875rem',
  paddingLeft: '1rem',
  paddingRight: '1rem',
})

export const CommunicationNote = styled('div', ({ $theme }) => ({
  borderLeft: `3px solid ${$theme.colors.primary}`,
  borderRadius: '0.5rem',
  backgroundColor: $theme.colors.bgLight,
  paddingTop: '0.5rem',
  paddingBottom: '0.5rem',
  paddingLeft: '0.75rem',
  paddingRight: '0.75rem',
  fontSize: '0.8125rem',
  lineHeight: '1.35',
  color: $theme.colors.textBody,
  overflowWrap: 'anywhere',
  '& p': { marginTop: 0, marginBottom: '0.375rem' },
  '& p:last-child': { marginBottom: 0 },
  '& ul, & ol': { marginTop: '0.25rem', marginBottom: '0.375rem', paddingLeft: '1.1rem' },
  '& ul:last-child, & ol:last-child': { marginBottom: 0 },
  '& li': { marginBottom: '0.125rem' },
  '& a': { color: $theme.colors.primary },
  '& strong, & b': { fontWeight: 600, color: $theme.colors.textHeading },
}))

export const StyledEmptyState = styled('div', ({ $theme }) => ({
  fontStyle: 'italic',
  fontSize: '0.8125rem',
  color: $theme.colors.textLight,
  textAlign: 'center',
  marginTop: 0,
  marginBottom: '1rem',
  marginLeft: '1rem',
  marginRight: '1rem',
}))
